import {Calculator, Heart} from 'lucide-react'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-gray-400 py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-emerald-500 flex items-center justify-center">
                <Calculator className="w-4 h-4 text-white" />
              </div>
              <span className="font-bold text-white text-lg" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                Fat<span className="text-emerald-400">Calc</span>
              </span>
            </div>
            <p className="text-sm leading-relaxed text-gray-500">
              Science-backed nutrition calculators to help you reach your health and fitness goals.
            </p>
          </div>

          {/* Tools */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4" style={{ fontFamily: "'DM Sans', sans-serif" }}>Tools</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#calculator" className="text-sm text-gray-500 hover:text-emerald-400 transition-colors">
                  Fat Intake Calculator
                </a>
              </li>
              <li>
                <Link to="/tdee-bmr-calculator" className="text-sm text-gray-500 hover:text-emerald-400 transition-colors">
                  TDEE & BMR Calculator
                </Link>
              </li>
              <li>
                <a href="#water" className="text-sm text-gray-500 hover:text-emerald-400 transition-colors">
                  Water Intake Calculator
                </a>
              </li>
              <li>
                <Link to="/history" className="text-sm text-gray-500 hover:text-emerald-400 transition-colors">
                  Saved Calculations
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4" style={{ fontFamily: "'DM Sans', sans-serif" }}>Resources</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#education" className="text-sm text-gray-500 hover:text-emerald-400 transition-colors">
                  How to Calculate Fat Intake
                </a>
              </li>
              <li>
                <Link to="/blog/tdee-vs-bmi-fat-intake" className="text-sm text-gray-500 hover:text-emerald-400 transition-colors">
                  TDEE vs BMI Blog
                </Link>
              </li>
              <li>
                <a href="#faq" className="text-sm text-gray-500 hover:text-emerald-400 transition-colors">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Disclaimer */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4" style={{ fontFamily: "'DM Sans', sans-serif" }}>Disclaimer</h4>
            <p className="text-xs text-gray-500 leading-relaxed">
              This calculator provides estimates based on established equations. Results should not replace professional medical or dietary advice. Always consult a healthcare provider.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-600">
            &copy; {new Date().getFullYear()} Fat Intake Tool. All rights reserved.
          </p>
          <p className="text-xs text-gray-600 flex items-center gap-1">
            Made with <Heart className="w-3 h-3 text-red-500" /> for your health
          </p>
        </div>
      </div>
    </footer>
  )
}
